import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { createForm } from 'rc-form'
import Cookies from 'js-cookie'

import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'

import { login } from 'actions/asyncMember'

import logo_black from 'static/images/icons/cellwine-logo-black.svg'
import google_favicon from 'static/images/icons/google-favicon-vector@3x.png'
import fb_favicon from 'static/images/icons/facebook@3x.png'

class CheckUserPage extends Component {

	componentWillReceiveProps(nextProps){
		const { isLogin, history } = nextProps
		const redirecting = Cookies.get('redirecting')

		if(isLogin && !this.props.isLogin){
			history.push('/member/setting/card', 'updatecard')
		}
		
		else if(isLogin && redirecting){
			history.push('/member/setting/card', 'updatecard')
			Cookies.remove('redirecting')
		}
	}

	loginFB = () => {
		this.props.login('facebook', {}, true)
	}

	loginGoogle = () => {
		this.props.login('google', {}, true)
	}

	loginEmail = () => {
		this.props.form.validateFields((error, value) => {
			if (!error) {
				this.props.login('email', value, true)
			}
		})
	}

	render() {
		const { t } = this.props
		const { getFieldProps, getFieldError } = this.props.form;
		const emailErr = getFieldError('email')
    const pwdErr = getFieldError('password')
		return (
			<div>
				<div className="row bg-white">
					<div className="container">
						<div className="row">
							<div className="col-12" style={{padding: '10px 0'}}>
									<img className="header-logo" src={logo_black} />
							</div>
						</div>
					</div>
				</div>

				<Grid container justify="center">
					<Grid item
						style={{
							marginTop: '50px',
							padding: '40px',
							backgroundColor: 'white',
						}}
					>
						<Button
		          size="small"
		          style={{ width: '100%', border: 'solid 2px #4568b2', backgroundColor: '#4568b2', color: 'white', marginBottom: '16px', padding: '10px 0' }}
		          onClick={this.loginFB}
		      	>
		          <img src={fb_favicon} style={{ width: '11px', marginRight: '47px' }} alt="facebook" />
		          <Typography color="inherit">使用 Facebook 帳號繼續</Typography>
			      </Button>
			      <Button
		          size="small"
		          style={{ width: '100%', border: 'solid 2px rgba(74, 79, 85, 0.1)', backgroundColor: 'white', color: '#9fa2a3', padding: '10px 0' }}
		          onClick={this.loginGoogle}
		      	>
		          <img src={google_favicon} style={{ width: '19px', marginRight: '47px' }} alt="google" />
		          <Typography color="inherit">使用 Google 帳號繼續</Typography>
		      	</Button>
						<div className="d-flex align-items-center" style={{ margin: '28px 0 12px 0' }}>
              <div style={{ height: '1px', width: '100%', backgroundColor: 'rgba(74, 79, 85, 0.1)' }}></div>
              <span style={{ color: '#9fa2a3', margin: '0 24px' }}><Typography color="inherit">或</Typography></span>
              <div style={{ height: '1px', width: '100%', backgroundColor: 'rgba(74, 79, 85, 0.1)' }}></div>
          	</div>
						<TextField
              name="email"
              id="email"
              size="small"
              variant="outlined"
              placeholder="電子郵件"
              inputProps={{
                  ...getFieldProps('email', {
                      initialValue: '',
                      rules: [{
                          type: 'email',
                          required: true
                      }]
                  })
              }}
              margin="normal"
              style={{ width: '100%' }}
              error={emailErr && emailErr !== null}
              helperText={emailErr || ''}
              FormHelperTextProps={{
                  error: emailErr && emailErr !== null
              }}
          	/>
          	<TextField
              name="password"
              id="password"
              type="password"
              size="small"
              variant="outlined"
              placeholder="密碼"
              inputProps={{
                  ...getFieldProps('password', {
                      initialValue: '',
                      rules: [{
                          required: true
                      }]
                  })
              }}
              margin="normal"
              style={{ width: '100%' }}
              error={pwdErr && pwdErr !== null}
              helperText={pwdErr || ''}
              FormHelperTextProps={{
                  error: pwdErr && pwdErr !== null
              }}
            />
						<Grid container justify="flex-end" alignItems="center" style={{ marginTop: '20px' }}>
              {/* <Typography className="typography pointer">
                  <span
										// onClick={() => onActionChange('forgetpassword')}
									>忘記密碼</span>
              </Typography> */}
              <Button color="primary" variant="contained"
								onClick={this.loginEmail}
							>
                  {t('login')}
              </Button>
            </Grid>
					</Grid>
				</Grid>

			</div>
		)
	}
}

const mapStateToProps = state => ({
	isLogin: state.member.isLogin
})

const mapDispatchToProps = (dispatch, ownProps) => bindActionCreators({
	login,
}, dispatch)

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withTranslation()(createForm()(CheckUserPage)))